import { Abstrap } from '../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'p' };

class AdvertText extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-advert__text',
            className,
        ];
    }

}

AdvertText.propTypes = propTypes;

AdvertText.defaultProps = defaultProps;

export default AdvertText;
